var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1899 9.39998C16.2899 6.80998 13.6799 5.05998 10.8899 5.26998C7.88995 5.48998 5.47995 7.92998 5.23995 10.85C3.90995 11.13 2.81995 12.07 2.41995 13.34C2.37995 13.48 2.33995 13.61 2.31995 13.75C2.13995 14.7 2.38995 15.64 3.02995 16.41C3.71995 17.25 4.79995 17.75 5.89995 17.75H17.9299C18.9399 17.75 19.8899 17.35 20.5499 16.66C21.3999 15.77 21.8399 14.62 21.7699 13.52C21.6299 11.34 19.6399 9.58998 17.2199 9.39998H17.1899ZM19.4399 15.63C19.0699 16.02 18.5099 16.25 17.9099 16.25H5.87995C5.21995 16.25 4.57995 15.95 4.16995 15.46C3.81995 15.04 3.68995 14.54 3.77995 14.04C3.79995 13.96 3.81995 13.88 3.83995 13.8C4.12995 12.91 4.98995 12.29 5.98995 12.26C6.39995 12.25 6.72995 11.9 6.70995 11.49C6.62995 9.06998 8.54995 6.94998 10.9899 6.76998C11.0999 6.76998 11.2199 6.75998 11.3299 6.75998C13.4599 6.75998 15.3899 8.23998 15.8899 10.32C15.9699 10.66 16.2899 10.93 16.6399 10.89C18.6499 10.84 20.1499 12.26 20.2399 13.62C20.2799 14.31 19.9899 15.04 19.4299 15.64L19.4399 15.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4699 11.47L12.7499 12.19V10C12.7499 9.59 12.4099 9.25 11.9999 9.25C11.5899 9.25 11.2499 9.59 11.2499 10V12.19L10.5299 11.47C10.2399 11.18 9.75994 11.18 9.46994 11.47C9.17994 11.76 9.17994 12.24 9.46994 12.53L11.4699 14.53C11.5399 14.6 11.6199 14.65 11.7099 14.69C11.7999 14.73 11.8999 14.75 11.9999 14.75C12.0999 14.75 12.1899 14.73 12.2899 14.69C12.3799 14.65 12.4599 14.6 12.5299 14.53L14.5299 12.53C14.8199 12.24 14.8199 11.76 14.5299 11.47C14.2399 11.18 13.7599 11.18 13.4699 11.47Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPreview);
export default __webpack_public_path__ + "static/media/downloadPreview.8f71a87a.svg";
export { ForwardRef as ReactComponent };